
import axios from 'axios'

let baseUrl = process.env.VUE_APP_API_BASE_URL

function getGadgetDropdowns (callback) {
  axios.get(baseUrl + '/api/v1/gadget/dropdowns/')
    .then(function (res) {
      callback(null, res.data)
    })
    .catch(function (err) {
      callback(err, null)
    })
}

export class GadgetAPI {
  static getDamageTypes (deviceTypeId, incidentTypeId) {
    return axios.get(baseUrl + '/api/v1/gadget/damagetypes/' + deviceTypeId + '/' + incidentTypeId)
  }
  static getDeviceTypes () {
    return axios.get(baseUrl + '/api/v1/gadget/gadgettypes/')
  }
  static getDeviceMakes (deviceTypeId) {
    return axios.get(baseUrl + '/api/v1/gadget/gadgetmakes/' + deviceTypeId)
  }
  static getDeviceModels (deviceTypeId, deviceMakeId) {
    return axios.get(baseUrl + '/api/v1/gadget/gadgetmodels/' + deviceTypeId + '/' + deviceMakeId)
  }
}

export { getGadgetDropdowns }
